const avtoPathesHead = {
  city: (data, p) => ({
    header: `${p.buy} авто бу ${p.inCity}`,

    title: `Автобазар ${p.t(data.city)}. Купить авто бу ${p.inCity} с пробегом на авторынке`,
    title_uk: `Автобазар ${p.t(data.city)}. Купити авто бу ${p.inCity} з пробігом на авторинку`,

    description: `Продажа бу авто 🚗 ${p.inCity}. Купить авто бу ${p.inCity} с пробегом на Автобазар. Большой выбор объявлений. Выгодная цена. Проверенные продавцы`,
    description_uk: `Продаж бу авто 🚗 ${p.inCity}. Купити авто бу ${p.inCity} з пробігом на Автобазар. Великий вибір оголошень. Вигідна ціна. Перевірені продавці`,
  }),

  make: (data, p) => ({
    title: `Купить ${data.make} бу в Украине. Продажа ${data.make} с пробегом. Цена авто, фото - Автобазар`,
    title_uk: `Купити ${data.make} бу в Україні. Продаж ${data.make} з пробігом. Ціна авто, фото - Автобазар`,

    description: `Купить ${data.make} бу в Украине. Подержанные машины ${data.make} с пробегом в продаже на авто базаре. Сравнить цены на автомобили, посмотреть фото, характеристики, комплектацию модели. Весь модельный ряд ${data.make} в каталоге на сайте Автобазар`,
    description_uk: `Купити ${data.make} бу в Україні. Старі машини ${data.make} з пробігом в продажу на авто базарі. Порівняти ціни на автомобілі, подивитися фото, характеристики, комплектацію моделі. Весь модельний ряд ${data.make} в каталозі на сайті Автобазар`,
  }),

  country: (data, p) => ({
    header: `${p.buy} авто бу ${p.fromCountry}`,

    title: `Автобазар ${p.country}. Купить авто бу ${p.fromCountry} с пробегом на авторынке`,
    title_uk: `Автобазар ${p.country}. Купити авто бу ${p.fromCountry} з пробігом на авторинку`,

    description: `Продажа бу авто в ${p.country}. Купить авто бу в ${p.country} с пробегом на Автобазар. Большой выбор объявлений. Выгодная цена. Проверенные продавцы`,
    description_uk: `Продаж бу авто в ${p.country}. Купити авто бу в ${p.country} з пробігом на Автобазар. Великий вибір оголошень. Вигідна ціна. Перевірені продавці`,
  }),

  engine: (data, p) => ({
    header: `${p.buy} ${p.t(data.engine).toLowerCase()} ${p.t('автомобиль')} бу`,
  }),

  body: (data, p) => ({
    title: `${p.buy} бу ${p.t(data.body)} ${p.t('в Украине')} – Автобазар`,
    header: `${p.buy} ${p.t(data.body)} бу ${p.t('в Украине')}`,

    description: `${p.buy} бу ${p.t(data.body)} с пробегом в Украине. Большой выбор марок и моделей. Сравнить цены, посмотреть фото на сайте Автобазар`,
    description_uk: `${p.buy} бу ${p.t(data.body)} з пробігом в Україні. Великий вибір марок і моделей. Порівняти ціни, подивитися фото на сайті Автобазар`,
  }),

  gearbox: (data, p) => ({ header: `${p.buy} авто ${p.customGearbox} бу` }),

  year: (data, p) => ({
    title: `Автомобили ${data.year} года купить в Украине - Автобазар`,
    title_uk: `Автомобілі ${data.year} року купити в Україні - Автобазар`,

    description: `Продажа авто ${data.year} года бу в Украине. Большой выбор марок и моделей автомобилей. Сравнить цены, посмотреть фото в объявлениях на Автобазар`,
    description_uk: `Продаж авто ${data.year} року бу в Україні. Великий вибір марок і моделей автомобілів. Порівняти ціни, подивитися фото в оголошеннях на Автобазар`,
  }),

  // --- //

  gearboxCity: (data, p) => ({ header: `${p.buy} авто ${p.customGearbox.toLowerCase()} бу ${p.t(data.city)}` }),

  cityEngine: (data, p) => ({ header: `${p.t(data.engine)} авто бу ${p.buyLCase} ${p.inCity}` }),

  makeModel: (data, p) => ({
    title: `Купить ${data.make} ${data.model} в Украине. Продажа ${data.make} ${data.model} бу. Цена авто - Автобазар`,
    title_uk: `Купити ${data.make} ${data.model} в Україні. Продаж ${data.make} ${data.model} бу. Ціна авто - Автобазар`,

    description: `Купить ${data.make} ${data.model} бу в Украине. В продаже подержанные машины ${data.make} ${data.model} с пробегом на авто рынке. Сравнить цены на автомобили, посмотреть фото, обзор комплектации и характеристик автомобилей на сайте Автобазар`,
    description_uk: `Купити ${data.make} ${data.model} бу в Україні. У продажу старі машини ${data.make} ${data.model} з пробігом на авто ринку. Порівняти ціни на автомобілі, подивитися фото, огляд комплектації і характеристик автомобілів на сайті Автобазар`,
  }),

  makeCity: (data, p) => ({
    title: `Купить ${data.make} ${p.inCity}. Продажа ${data.make} бу ${p.t(data.city)}. Цены на авто - Автобазар`,
    title_uk: `Купити ${data.make} ${p.inCity}. Продаж ${data.make} бу ${p.t(data.city)}. Ціни на авто - Автобазар`,

    description: `Купить автомобиль ${data.make} бу ${p.inCity}. Продажа авто ${data.make} с пробегом ${p.inCity}. Цены на подержанные на машины, фото, характеристики и комплектацию автомобилей марки смотрите в каталоге объявлений на сайте Автобазар`,
    description_uk: `Купити автомобіль ${data.make} бу ${p.inCity}. Продаж авто ${data.make} з пробігом ${p.inCity}. Ціни на старі на машини, фото, характеристики і комплектацію автомобілів марки дивіться в каталозі оголошень на сайті Автобазар`,
  }),

  makeCountry: (data, p) => ({
    title: `Купить ${data.make} ${p.fromCountry}. Продажа ${data.make} бу ${p.fromCountry} в Украине. Цена авто - Автобазар`,
    title_uk: `Купити ${data.make} ${p.fromCountry}. Продаж ${data.make} бу ${p.fromCountry} в Україні. Ціна авто - Автобазар`,

    description: `Купить автомобиль ${data.make} бу ${p.fromCountry}. Продажа авто ${data.make} с пробегом пригнанных ${p.fromCountry} в Украину. Сравнить цены на подержанные машины, посмотреть фото, обзор характеристик и комплектации автомобилей на сайте Автобазар`,
    description_uk: `Купити автомобіль ${data.make} бу ${p.fromCountry}. Продаж авто ${data.make} з пробігом привезені ${p.fromCountry} в Україні. Порівняти ціни на старі машини, подивитися фото, огляд характеристик і комплектації автомобілів на сайті Автобазар`,
  }),

  cityYear: (data, p) => ({
    title: `Автомобили ${data.year} года купить ${p.inCity} - Автобазар`,
    title_uk: `Автомобілі ${data.year} року купити ${p.inCity} - Автобазар`,

    description: `Продажа авто ${data.year} года бу ${p.inCity}. Большой выбор марок и моделей автомобилей. Сравнить цены, посмотреть фото в объявлениях на Автобазар`,
    description_uk: `Продаж авто ${data.year} року бу ${p.inCity}. Великий вибір марок і моделей автомобілів. Порівняти ціни, подивитися фото в оголошеннях на Автобазар`,
  }),

  bodyYear: (data, p) => ({
    header: `${p.buy} ${p.t(data.body)} ${data.year} года`,
    header_uk: `${p.buy} ${p.t(data.body)} ${data.year} року`,

    title: `Купить ${p.t(data.body)} ${data.year} года в Украине – Автобазар`,
    title_uk: `Купити ${p.t(data.body)} ${data.year} року в Україні – Автобазар`,

    description: `Купить ${p.t(data.body)} ${data.year} года в Украине. Большой выбор марок и моделей. Сравнить цены, посмотреть фото на сайте Автобазар`,
    description_uk: `Купити ${p.t(data.body)} ${data.year} року в Україні. Великий вибір марок і моделей. Порівняти ціни, подивитися фото на сайті Автобазар`,
  }),

  bodyIsnew: (data, p) => ({
    header: `${p.buy} ${p.newTxtLCase} ${p.t(data.body)} ${p.t('в Украине')}`,
    title: `${p.buy} ${p.newTxtLCase} ${p.t(data.body)} ${p.t('в Украине')} – Автобазар`,

    description: `Купить новый ${p.t(data.body)} с салона в Украине. Большой выбор марок и моделей. Сравнить цены, посмотреть фото на сайте Автобазар`,
    description_uk: `Купити новий ${p.t(data.body)} з салону в Україні. Великий вибір марок і моделей. Порівняти ціни, подивитися фото на сайті Автобазар`,
  }),
  // Купить кроссовер в Украине

  bodyCity: (data, p) => ({
    header: `${p.buy} ${p.t(data.body).toLowerCase()} бу ${p.inCity}`,
    title: `${p.buy} бу ${p.t(data.body)} ${p.inCity} – Автобазар`,

    description: `${p.buy} бу ${p.t(data.body)} с пробегом ${p.inCity}. Большой выбор марок и моделей. Сравнить цены, посмотреть фото на сайте Автобазар`,
    description_uk: `${p.buy} бу ${p.t(data.body)} з пробігом ${p.inCity}. Великий вибір марок і моделей. Порівняти ціни, подивитися фото на сайті Автобазар`,
  }),
  // Купить кроссовер бу в Киеве

  gearboxIsnew: (data, p) => ({ header: `${p.buy} авто ${p.customGearbox}` }),
  // Купить авто Механика

  makeBody: (data, p) => ({
    header: `${data.make} ${p.t(data.body)} бу ${p.buyLCase} ${p.t('в Украине')}`,
    title: `${p.t(data.body)} ${data.make} бу ${p.buyLCase} ${p.t('в Украине')} – Автобазар`,

    description: `Купить ${p.t(data.body)} ${data.make} бу с пробегом в Украине. Большой выбор подержанных моделей. Сравнить цены, посмотреть фото на сайте Автобазар`,
    description_uk: `Купити ${p.t(data.body)} ${data.make} бу з пробігом в Україні. Великий вибір уживаних моделей. Порівняти ціни, подивитися фото на сайті Автобазар`,
  }),
  // BMW Кросовер бу купить в Украине

  makeEngine: (data, p) => ({ header: `${data.make} ${p.t(data.engine).toLowerCase()} бу` }),
  // BMW дизель бу

  makeGearbox: (data, p) => ({
    header: `${data.make} ${p.customGearboxLCase} бу ${p.buyLCase} ${p.t('в Украине')}`,
  }),
  // BMW механика бу купить в Украине

  bodyIsnewMake: (data, p) => ({
    title: `${p.newTxt} ${p.t(data.body)} ${data.make} ${p.buyLCase} ${p.t('в Украине')} – Автобазар`,
    header: `${p.buy} ${p.newTxtLCase} ${p.t(data.body)} ${data.make}`,

    description: `Новый ${p.t(data.body)} ${data.make} купить в Украине. Большой выбор моделей. Сравнить цены, посмотреть фото на сайте Автобазар`,
    description_uk: `Новий ${p.t(data.body)} ${data.make} купити в Україні. Великий вибір моделей. Порівняти ціни, подивитися фото на сайті Автобазар`,
  }),

  bodyIsnewYear: (data, p) => ({
    header: `${p.newTxt} ${p.t(data.body)} ${data.year} года`,
    header_uk: `${p.newTxt} ${p.t(data.body)} ${data.year} року`,

    title: `Новый ${p.t(data.body)} ${data.year} года купить ${p.t('в Украине')} – Автобазар`,
    title_uk: `Новий ${p.t(data.body)} ${data.year} року купити ${p.t('в Украине')} – Автобазар`,

    description: `Новый ${p.t(data.body)} ${data.year} года купить в Украине. Большой выбор марок и моделей. Сравнить цены, посмотреть фото на сайте Автобазар`,
    description_uk: `Новий ${p.t(data.body)} ${data.year} року купити в Україні. Великий вибір марок і моделей. Порівняти ціни, подивитися фото на сайті Автобазар`,
  }),

  makeGearboxIsnew: (data, p) => ({
    header: `${data.make} ${p.customGearboxLCase} ${p.buyLCase} ${p.t('в Украине')}`,
  }),
  // BMW механика купить в Украине

  gearboxIsnewCity: (data, p) => ({ header: `${p.buy} авто ${p.t(data.gearbox)} ${p.inCity}` }),
  // Купить авто Механика в Киеве

  makeGearboxCity: (data, p) => ({
    header: `${p.buy} ${data.make} ${p.t(data.gearbox).toLowerCase()} бу ${p.t(data.city)}`,
  }),
  // Купить BMW Механика бу в Киеве

  engineMakeModel: (data, p) => ({
    header: `${p.buy} ${data.make} ${data.model} ${p.customEngineShort} бу`,

    title: `Купить ${data.make} ${data.model} ${p.t(data.engine)} в Украине - Автобазар`,
    title_uk: `Купити ${data.make} ${data.model} ${p.t(data.engine)} в Україні - Автобазар`,

    description: `Продажа ${data.make} ${data.model} ${p.t(
      data.engine,
    )} в Украине. Купить ${data.make} ${data.model} ${p.t(
      data.engine,
    )} бу с пробегом на Автобазар. Большой выбор объявлений. Сравнить цены, посмотреть фото`,
    description_uk: `Продаж ${data.make} ${data.model} ${p.t(
      data.engine,
    )} в Україні. Купити ${data.make} ${data.model} ${p.t(
      data.engine,
    )} бу з пробігом на Автобазар. Великий вибір оголошень. Порівняти ціни, подивитися фото`,
  }),
  // Купить BMW X6 дизель бу

  makeModelCity: (data, p) => ({
    title: `Купить ${data.make} ${data.model} бу ${p.inCity}. Продажа ${data.make} ${data.model} на авто рынке - Автобазар`,
    title_uk: `Купити ${data.make} ${data.model} бу ${p.inCity}. Продаж ${data.make} ${data.model} на авто ринку - Автобазар`,

    description: `${data.make} ${data.model} купить бу ${p.inCity}. Подержанные машины ${data.make} ${data.model} с пробегом в продаже на авто рынке г. ${p.t(data.city)}. Сравнить цены на автомобили, посмотреть фото, обзор характеристик и комплектации модели на сайте Автобазар`,
    description_uk: `${data.make} ${data.model} купити бу ${p.inCity}. Старі машини ${data.make} ${data.model} з пробігом в продажу на автомобільному ринку м. ${p.t(data.city)}. Порівняти ціни на автомобілі, подивитися фото, огляд характеристик і комплектації моделі на сайті Автобазар`,
  }),

  makeModelYear: (data, p) => ({
    header: '',
    title: `Купить ${data.make} ${data.model} ${data.year} года в Украине - Автобазар`,
    title_uk: `Купити ${data.make} ${data.model} ${data.year} року в Україні - Автобазар`,

    description: `Продажа ${data.make} ${data.model} ${data.year} года в Украине. Купить ${data.make} ${data.model} ${data.year} бу с пробегом на Автобазар. Большой выбор объявлений. Сравнить цены, посмотреть фото`,
    description_uk: `Продаж ${data.make} ${data.model} ${data.year} року в Україні. Купити ${data.make} ${data.model} ${data.year} бу з пробігом на Автобазар. Великий вибір оголошень. Порівняти ціни, подивитися фото`,
  }),

  gearboxMakeModel: (data, p) => ({
    // header: '',
    title: `Купить ${data.make} ${data.model} ${p.customGearbox} в Украине - Автобазар`,
    title_uk: `Купити ${data.make} ${data.model} ${p.customGearbox} в Україні - Автобазар`,

    description: `Продажа ${data.make} ${data.model} ${p.customGearbox} в Украине. Купить ${data.make} ${data.model} ${p.customGearbox} бу с пробегом на Автобазар. Большой выбор объявлений. Сравнить цены, посмотреть фото`,
    description_uk: `Продаж ${data.make} ${data.model} ${p.customGearbox} в Україні. Купити ${data.make} ${data.model} ${p.customGearbox} бу з пробігом на Автобазар. Великий вибір оголошень. Порівняти ціни, подивитися фото`,
  }),

  bodyMakeModel: (data, p) => ({
    header: `${p.buy} ${p.t(data.body)} ${data.make} ${data.model}`,
    title: `${p.buy} ${data.make} ${data.model} ${p.t(data.body)} ${p.t('в Украине')} – Автобазар`,

    description: `Продажа ${data.make} ${data.model} ${p.t(data.body)} в Украине. Купить ${data.make} ${data.model} ${p.t(data.body)} бу с пробегом на Автобазар. Большой выбор объявлений. Сравнить цены, посмотреть фото`,
    description_uk: `Продаж ${data.make} ${data.model} ${p.t(data.body)} в Україні. Купити ${data.make} ${data.model} ${p.t(data.body)} бу з пробігом на Автобазар. Великий вибір оголошень. Порівняти ціни, подивитися фото`,
  }),
  // Купить Кросовер BMW X6 бу

  bodyCityIsnew: (data, p) => ({
    header: `${p.newTxt} ${p.t(data.body)} ${p.buyLCase} ${p.inCity}`,
    title: `${p.newTxt} ${p.t(data.body)} ${p.buyLCase} ${p.inCity} – Автобазар`,

    description: `Новый ${p.t(data.body)} купить ${p.inCity}. Большой выбор марок и моделей. Сравнить цены, посмотреть фото на сайте Автобазар`,
    description_uk: `Новий ${p.t(data.body)} купити ${p.inCity}. Великий вибір марок і моделей. Порівняти ціни, подивитися фото на сайті Автобазар`,
  }),
  // Купить Кросовер в Киеве

  bodyCityMake: (data, p) => ({
    header: `${data.make} ${p.t(data.body).toLowerCase()} бу ${p.t(data.city)}`,
    title: `${p.buy} бу ${p.t(data.body)} ${data.make} ${p.inCity} – Автобазар`,

    description: `Купить бу ${p.t(data.body)} ${data.make} с пробегом ${p.inCity}. Большой выбор моделей. Сравнить цены, посмотреть фото на сайте Автобазар`,
    description_uk: `Купити бу ${p.t(data.body)} ${data.make} з пробігом ${p.inCity}. Великий вибір моделей. Порівняти ціни, подивитися фото на сайті Автобазар`,
  }),
  // BMW Кроссовер бу в Киеве

  bodyCityYear: (data, p) => ({
    title: `Купить ${p.t(data.body)} ${data.year} года бу ${p.inCity} – Автобазар`,
    title_uk: `Купити ${p.t(data.body)} ${data.year} року бу ${p.inCity} – Автобазар`,

    description: `Продажа авто ${p.t(data.body)} ${data.year} года бу ${p.inCity}. Большой выбор марок и моделей. Сравнить цены, посмотреть фото в объявлениях на Автобазар`,
    description_uk: `Продаж авто ${p.t(data.body)} ${data.year} року бу ${p.inCity}. Великий вибір марок і моделей. Порівняти ціни, подивитися фото в оголошеннях на Автобазар`,
  }),

  cityEngineYear: (data, p) => ({
    title: `Купить авто ${p.t(data.engine)} ${data.year} года ${p.inCity} - Автобазар`,
    title_uk: `Купити авто ${p.t(data.engine)} ${data.year} року ${p.inCity} - Автобазар`,

    description: `Продажа авто ${p.t(data.engine)} ${data.year} года бу ${p.inCity}. Большой выбор марок и моделей. Сравнить цены, посмотреть фото в объявлениях на Автобазар`,
    description_uk: `Продаж авто ${p.t(data.engine)} ${data.year} року бу ${p.inCity}. Великий вибір марок і моделей. Порівняти ціни, подивитися фото в оголошеннях на Автобазар`,
  }),

  bodyCityIsnewMake: (data, p) => ({
    header: `${p.newTxt} ${data.make} ${p.t(data.body)} ${p.inCity}`,
    title: `${p.buy} ${p.newTxtLCase} ${p.t(data.body)} ${data.make} ${p.inCity} – Автобазар`,

    description: `Купить новый ${p.t(data.body)} ${data.make} ${p.inCity} с салона. Большой выбор моделей. Сравнить цены, посмотреть фото на сайте Автобазар`,
    description_uk: `Купити новий ${p.t(data.body)} ${data.make} ${p.inCity} з салону. Великий вибір моделей. Порівняти ціни, подивитися фото на сайті Автобазар`,
  }),

  bodyCityMakeModel: (data, p) => ({
    header: `${p.buy} ${p.t(data.body).toLowerCase()} ${data.make} ${data.model} бу ${p.t(data.city)}`,

    title: `${p.buy} ${data.make} ${data.model} ${p.t(data.body)} ${p.inCity} – Автобазар`,

    description: `Продажа ${data.make} ${data.model} ${p.t(data.body)} ${p.inCity}. Купить ${data.make} ${data.model} ${p.t(data.body)} бу с пробегом на Автобазар. Большой выбор объявлений ${p.inCity}. Сравнить цены, посмотреть фото`,
    description_uk: `Продаж ${data.make} ${data.model} ${p.t(data.body)} ${p.inCity}. Купити ${data.make} ${data.model} ${p.t(data.body)} бу з пробігом на Автобазар. Великий вибір оголошень ${p.inCity}. Порівняти ціни, подивитися фото`,
  }),

  countryMakeModel: (data, p) => ({
    header: `${p.buy} ${data.make} ${data.model} ${p.fromCountry} бу`,

    title: `Купить ${data.make} ${data.model} ${p.fromCountry} - Автобазар`,
    title_uk: `Купити ${data.make} ${data.model} ${p.fromCountry} - Автобазар`,

    description: `Купить ${data.make} ${data.model} пригнанный ${p.fromCountry}. В продаже ${data.make} ${data.model} бу с пробегом растаможенный и нерастаможенный. Большой выбор объявлений. Сравнить цены, посмотреть фото`,
    description_uk: `Купити ${data.make} ${data.model} пригнаний ${p.fromCountry}. У продажу ${data.make} ${data.model} бу з пробігом розмитнений і нерозмитнений. Великий вибір оголошень. Порівняти ціни, подивитися фото`,
  }),

  makeModelEngineCity: (data, p) => ({
    header: `${p.buy} ${data.make} ${data.model} ${p.customEngineShort} бу ${p.inCity}`,
    title: `Купить ${data.make} ${data.model} ${p.t(data.engine)} ${p.inCity} - Автобазар`,
    title_uk: `Купити ${data.make} ${data.model} ${p.t(data.engine)} ${p.inCity} - Автобазар`,

    description: `Продажа ${data.make} ${data.model} ${p.t(
      data.engine,
    )} ${p.inCity}. Купить ${data.make} ${data.model} ${p.t(
      data.engine,
    )} бу с пробегом на Автобазар. Большой выбор объявлений ${p.inCity}. Сравнить цены, посмотреть фото`,
    description_uk: `Продаж ${data.make} ${data.model} ${p.t(
      data.engine,
    )} ${p.inCity}. Купити ${data.make} ${data.model} ${p.t(
      data.engine,
    )} бу з пробігом на Автобазар. Великий вибір оголошень ${p.inCity}. Порівняти ціни, подивитися фото`,
  }),
  // Купить BMW X6 дизель бу в Киеве

  cityGearboxMakeModel: (data, p) => ({
    header: `${p.buy} ${data.make} ${data.model} ${p.customGearbox.toLowerCase()} бу ${p.t(data.city)}`,
    title: `Купить ${data.make} ${data.model} ${p.customGearbox} ${p.inCity} - Автобазар`,
    title_uk: `Купити ${data.make} ${data.model} ${p.customGearbox} ${p.inCity} - Автобазар`,

    description: `Продажа ${data.make} ${data.model} ${p.customGearbox} ${p.inCity}. Купить ${data.make} ${data.model} ${p.customGearbox} бу с пробегом на Автобазар. Большой выбор объявлений. Сравнить цены ${p.inCity}, посмотреть фото`,
    description_uk: `Продаж ${data.make} ${data.model} ${p.customGearbox} ${p.inCity}. Купити ${data.make} ${data.model} ${p.customGearbox} бу з пробігом на Автобазар. Великий вибір оголошень. Порівняти ціни ${p.inCity}, подивитися фото`,
  }),
  // Купить BMW X6 Механика бу в Киеве

  cityGearboxIsnewMake: (data, p) => ({
    header: `${p.buy} ${data.make} ${p.customGearbox} ${p.inCity}`,
  }),
  // Купить BMW Механика в Киеве

  cityMakeModelYear: (data, p) => ({
    header: `${p.buy} ${data.make} ${data.model} ${data.year} бу ${p.inCity}`,

    title: `Купить ${data.make} ${data.model} ${data.year} года ${p.inCity} - Автобазар`,
    title_uk: `Купити ${data.make} ${data.model} ${data.year} року ${p.inCity} - Автобазар`,

    description: `Продажа ${data.make} ${data.model} ${data.year} года ${p.inCity}. Купить ${data.make} ${data.model} ${data.year} бу с пробегом на Автобазар. Большой выбор объявлений. Сравнить цены ${p.inCity}, посмотреть фото`,
    description_uk: `Продаж ${data.make} ${data.model} ${data.year} року ${p.inCity}. Купити ${data.make} ${data.model} ${data.year} бу з пробігом на Автобазар. Великий вибір оголошень. Порівняти ціни ${p.inCity}, подивитися фото`,
  }),

  makeModelEngineCityYear: (data, p) => ({
    header: `${p.buy} ${data.make} ${data.model} ${data.year} бу ${p.inCity}`,
  }),

  //
  bodyCityIsnewYear: (data, p) => ({
    title: `Купить новый ${p.t(data.body)} ${data.year} года с салона ${p.inCity} - Автобазар`,
    description: `Продажа новых ${p.t(data.body)} ${data.year} года с салона ${p.inCity}. Большой выбор марок и моделей. Сравнить цены, посмотреть фото в объявлениях от автосалонов на Автобазар`,
    title_uk: `Купити новий ${p.t(data.body)} ${data.year} року з салону ${p.inCity} - Автобазар`,
    description_uk: `Продаж нових ${p.t(data.body)} ${data.year} року з салону ${p.inCity}. Великий вибір марок і моделей. Порівняти ціни, подивитися фото в оголошеннях від автосалонів на Автобазар`,
  }),
  isnewYear: (data, p) => ({
    title: `Новые автомобили ${data.year} года купить в автосалонах Украины - Автобазар`,
    description: `Продажа новых авто ${data.year} года в автосалонах Украины. Большой выбор марок и моделей автомобилей. Сравнить цены, посмотреть фото с салона в объявлениях на Автобазар`,
    title_uk: `Нові автомобілі ${data.year} року купити в автосалонах України - Автобазар`,
    description_uk: `Продаж нових авто ${data.year} року в автосалонах України. Великий вибір марок і моделей автомобілів. Порівняти ціни, подивитися фото з салону в оголошеннях на Автобазар`,
  }),
  cityIsnewYear: (data, p) => ({
    title: `Новые автомобили ${data.year} года купить в автосалонах города ${p.t(data.city)} - Автобазар`,
    description: `Продажа новых авто ${data.year} года в автосалонах города ${p.t(data.city)}. Большой выбор марок и моделей. Сравнить цены, посмотреть фото в объявлениях на Автобазар`,
    title_uk: `Нові автомобілі ${data.year} року купити в автосалонах міста ${p.t(data.city)} - Автобазар`,
    description_uk: `Продаж нових авто ${data.year} року в автосалонах міста ${p.t(data.city)}. Великий вибір марок і моделей. Порівняти ціни, подивитися фото в оголошеннях на Автобазар`,
  }),
  cityIsnew: (data, p) => ({
    title: `Купить новое авто с салона ${p.inCity} - Автобазар`,
    description: `Продажа новых авто в автосалонах города ${p.t(data.city)}. Большой выбор машин. Выгодная цена. Еще больше объявлений от салонов на сайте Автобазар`,
    title_uk: `Купити нове авто з салону ${p.inCity} - Автобазар`,
    description_uk: `Продаж нових авто в автосалонах міста ${p.t(data.city)}. Великий вибір машин. Вигідна ціна. Ще більше оголошень від салонів на сайті Автобазар`,
  }),
  isnewMakeModelYear: (data, p) => ({
    title: `Купить новый ${data.make} ${data.model} ${data.year} года с салона в Украине - Автобазар`,
    description: `Продажа новых ${data.make} ${data.model} ${data.year} года в автосалонах Украины. Большой выбор объявлений. Сравнить цены, выбрать выгодное предложение от салона на сайте Автобазар`,
    title_uk: `Купити новий ${data.make} ${data.model} ${data.year} року з салону в Україні - Автобазар`,
    description_uk: `Продаж нових ${data.make} ${data.model} ${data.year} року в автосалонах України. Великий вибір оголошень. Порівняти ціни, вибрати вигідну пропозицію від салону на сайті Автобазар`,
  }),
  cityIsnewMakeModelYear: (data, p) => ({
    title: `Купить новый ${data.make} ${data.model} ${data.year} года с салона ${p.inCity} - Автобазар`,
    description: `Продажа новых ${data.make} ${data.model} ${data.year} года в автосалонах города ${p.t(data.city)}. Большой выбор объявлений. Сравнить цены ${p.inCity}, выбрать лучшее предложение от салона на сайте Автобазар`,
    title_uk: `Купити новий ${data.make} ${data.model} ${data.year} року з салону ${p.inCity} - Автобазар`,
    description_uk: `Продаж нових ${data.make} ${data.model} ${data.year} року в автосалонах міста ${p.t(data.city)}. Великий вибір оголошень. Порівняти ціни ${p.inCity}, вибрати кращу пропозицію від салону на сайті Автобазар`,
  }),
  gearboxIsnewMakeModel: (data, p) => ({
    title: `Купить новый ${data.make} ${data.model} ${p.customGearbox} с салона в Украине - Автобазар`,
    description: `Продажа новых ${data.make} ${data.model} ${p.customGearbox} в автосалонах Украины. Большой выбор объявлений. Сравнить цены в салонах, выбрать лучшее предложение на сайте Автобазар`,
    title_uk: `Купити новий ${data.make} ${data.model} ${p.customGearbox} з салону в Україні - Автобазар`,
    description_uk: `Продаж нових ${data.make} ${data.model} ${p.customGearbox} в автосалонах України. Великий вибір оголошень. Порівняти ціни в салонах, вибрати кращу пропозицію на сайті Автобазар`,
  }),
  cityGearboxIsnewMakeModel: (data, p) => ({
    title: `Купить новый ${data.make} ${data.model} ${p.customGearbox} в автосалонах ${p.t(data.city)} - Автобазар`,
    description: `Продажа новых ${data.make} ${data.model} ${p.customGearbox} в автосалонах города ${p.t(data.city)}. Большой выбор объявлений. Сравнить цены в салонах ${p.t(data.city)}, выбрать лучшее предложение на сайте Автобазар`,
    title_uk: `Купити новий ${data.make} ${data.model} ${p.customGearbox} в автосалонах ${p.t(data.city)} - Автобазар`,
    description_uk: `Продаж нових ${data.make} ${data.model} ${p.customGearbox} в автосалонах міста ${p.t(data.city)}. Великий вибір оголошень. Порівняти ціни в салонах ${p.t(data.city)}, вибрати кращу пропозицію на сайті Автобазар`,
  }),
  engineIsnewMakeModel: (data, p) => ({
    title: `Купить новый ${data.make} ${data.model} ${p.t(data.engine)} с салона в Украине - Автобазар`,
    description: `Продажа новых ${data.make} ${data.model} ${p.t(data.engine)} в автосалонах Украины. Большой выбор объявлений. Сравнить цены, выбрать лучшее предложение на сайте Автобазар`,
    title_uk: `Купити новий ${data.make} ${data.model} ${p.t(data.engine)} з салону в Україні - Автобазар`,
    description_uk: `Продаж нових ${data.make} ${data.model} ${p.t(data.engine)} в автосалонах України. Великий вибір оголошень. Порівняти ціни, вибрати кращу пропозицію на сайті Автобазар`,
  }),
  cityEngineIsnewMakeModel: (data, p) => ({
    title: `Купить новый ${data.make} ${data.model} ${p.t(data.engine)} с салона ${p.inCity} - Автобазар`,
    description: `Продажа новых ${data.make} ${data.model} ${p.t(data.engine)} в автосалонах города ${p.t(data.city)}. Большой выбор объявлений от салонов. Выбрать лучшее предложение на сайте Автобазар`,
    title_uk: `Купити новий ${data.make} ${data.model} ${p.t(data.engine)} з салону ${p.inCity} - Автобазар`,
    description_uk: `Продаж нових ${data.make} ${data.model} ${p.t(data.engine)} в автосалонах міста ${p.t(data.city)}. Великий вибір оголошень від салонів. Вибрати кращу пропозицію на сайті Автобазар`,
  }),
  bodyIsnewMakeModel: (data, p) => ({
    header: `${p.buy} ${p.newTxtLCase} ${p.t(data.body)} ${data.make} ${data.model}`,
    title: `Купить новый ${data.make} ${data.model} ${p.t(data.body)} с салона в Украине - Автобазар`,
    description: `Продажа новых ${data.make} ${data.model} ${p.t(data.body)} в автосалонах Украины. Большой выбор объявлений. Сравнить цены, выбрать лучшее предложение от салона на сайте Автобазар`,
    title_uk: `Купити новий ${data.make} ${data.model} ${p.t(data.body)} з салону в Україні - Автобазар`,
    description_uk: `Продаж нових ${data.make} ${data.model} ${p.t(data.body)} в автосалонах України. Великий вибір оголошень. Порівняти ціни, вибрати кращу пропозицію від салону на сайті Автобазар`,
  }),
  bodyCityIsnewMakeModel: (data, p) => ({
    header: `${p.newTxt} ${p.t(data.body)} ${data.make} ${data.model} ${p.inCity}`,
    title: `Купить новый ${data.make} ${data.model} ${p.t(data.body)} с салона ${p.inCity} - Автобазар`,
    description: `Продажа новых ${data.make} ${data.model} ${p.t(data.body)} в автосалонах города ${p.t(data.city)}. Большой выбор объявлений. Сравнить цены, выбрать лучшее предложение от салона на сайте Автобазар`,
    title_uk: `Купити новий ${data.make} ${data.model} ${p.t(data.body)} з салону ${p.inCity} - Автобазар`,
    description_uk: `Продаж нових ${data.make} ${data.model} ${p.t(data.body)} в автосалонах міста ${p.t(data.city)}. Великий вибір оголошень. Порівняти ціни, вибрати кращу пропозицію від салону на сайті Автобазар`,
  }),
  countryIsnewMakeModel: (data, p) => ({
    title: `Купить новый ${data.make} ${data.model} ${p.fromCountry} - Автобазар`,
    description: `Купить новый ${data.make} ${data.model} пригнанный ${p.fromCountry}. Большой выбор объявлений. Сравнить цены, выбрать лучшее предложение на сайте Автобазар`,
    title_uk: `Купити новий ${data.make} ${data.model} ${p.fromCountry} - Автобазар`,
    description_uk: `Купити новий ${data.make} ${data.model} пригнаний ${p.fromCountry}. Великий вибір оголошень. Порівняти ціни, вибрати кращу пропозицію на сайті Автобазар`,
  }),
  cityEngineIsnewYear: (data, p) => ({
    title: `Купить новый ${p.t(data.engine)} авто ${data.year} года с салона ${p.inCity} - Автобазар`,
    description: `Продажа новых авто ${p.t(data.engine)} ${data.year} года с салона ${p.inCity}. Большой выбор марок и моделей. Сравнить цены, посмотреть фото в объявлениях от автосалонов на Автобазар`,
    title_uk: `Купити новий ${p.t(data.engine)} авто ${data.year} року з салону ${p.inCity} - Автобазар`,
    description_uk: `Продаж нових авто ${p.t(data.engine)} ${data.year} року з салону ${p.inCity}. Великий вибір марок і моделей. Порівняти ціни, подивитися фото в оголошеннях від автосалонів на Автобазар`,
  }),
};

export default avtoPathesHead;



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/search/avto/templates.js